import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-auth-callback',
  template: `<p>Logging in...</p>`
})
export class AuthCallbackComponent implements OnInit {

  constructor(private authService: AuthService, private router: Router,private http:HttpClient) {}

  async ngOnInit() {
    try {
      const user = await this.authService.handleCallback();

       // ✅ Step 2: Call YOUR backend API
      this.http.get<any>(`${environment.legalAssureApiBaseUrl}Auth/profile`).subscribe(res => {
        console.log(res);
        // ✅ Step 4: Redirect to app
        localStorage.setItem("profile",JSON.stringify(res));
        this.router.navigate(['/sample-page/sample-page1']);

      });

    } catch (error) {
      console.error(error);
      this.router.navigate(['/login']);
    }

    } catch (err) {
      console.error(err);
    }
  }